
import React, { useState } from "react";
import { Link, Routes, Route, NavLink } from "react-router-dom";
import logo from "../assets/logo.png";

import Dashboard from "../screens/librarian/Dashboard";
import Books from "../screens/librarian/Books";
import AddBook from "../screens/librarian/AddBook";
import Profile from "../screens/librarian/Profile";
import ManageEvents from "../screens/librarian/ManageEvents";
import Announcement from "../screens/librarian/Announcement";

import "./LibrarianLayout.css";

const LibrarianLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className="librarian-layout">

      {/* ================= NAVBAR ================= */}

      <header className="librarian-navbar">

        {/* Logo */}
        <Link
          to="/librarian"
          className="librarian-logo-container"
          onClick={closeMenu}
        >
          <img
            src={logo}
            alt="Ghalib Library Logo"
            className="librarian-logo-image"
          />

          <div>
            <div className="librarian-logo">
              Ghalib Library
            </div>

            <div className="librarian-logo-sub">
              Library Management System
            </div>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="librarian-desktop-links">

          <NavLink
            to="/librarian"
            end
            className={({ isActive }) =>
              `librarian-link ${
                isActive ? "librarian-active-link" : ""
              }`
            }
          >
            Dashboard
          </NavLink>

          <NavLink
            to="/librarian/books"
            end
            className={({ isActive }) =>
              `librarian-link ${
                isActive ? "librarian-active-link" : ""
              }`
            }
          >
            Books
          </NavLink>

          <NavLink
            to="/librarian/add-book"
            end
            className={({ isActive }) =>
              `librarian-link ${
                isActive ? "librarian-active-link" : ""
              }`
            }
          >
            Add Book
          </NavLink>

          <NavLink
            to="/librarian/manageevents"
            end
            className={({ isActive }) =>
              `librarian-link ${
                isActive ? "librarian-active-link" : ""
              }`
            }
          >
            Events
          </NavLink>

          <NavLink
            to="/librarian/announcement"
            end
            className={({ isActive }) =>
              `librarian-link ${
                isActive ? "librarian-active-link" : ""
              }`
            }
          >
            Announcement
          </NavLink>

          <NavLink
            to="/librarian/profile"
            end
            className={({ isActive }) =>
              `librarian-link ${
                isActive ? "librarian-active-link" : ""
              }`
            }
          >
            Profile Setting
          </NavLink>

          <Link
            to="/"
            className="librarian-logout"
          >
            Logout
          </Link>

        </nav>

        {/* Mobile Menu Button */}
        <button
          className="librarian-menu-button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle librarian navigation"
          aria-expanded={menuOpen}
        >
          {menuOpen ? "✕" : "☰"}
        </button>

        {/* Mobile Navigation */}
        <nav
          className={`librarian-mobile-menu ${
            menuOpen ? "librarian-mobile-menu-open" : ""
          }`}
        >

          <NavLink
            to="/librarian"
            end
            onClick={closeMenu}
            className={({ isActive }) =>
              `librarian-mobile-link ${
                isActive ? "librarian-mobile-active" : ""
              }`
            }
          >
            Dashboard
          </NavLink>

          <NavLink
            to="/librarian/books"
            onClick={closeMenu}
            className={({ isActive }) =>
              `librarian-mobile-link ${
                isActive ? "librarian-mobile-active" : ""
              }`
            }
          >
            Books
          </NavLink>

          <NavLink
            to="/librarian/add-book"
            onClick={closeMenu}
            className={({ isActive }) =>
              `librarian-mobile-link ${
                isActive ? "librarian-mobile-active" : ""
              }`
            }
          >
            Add Book
          </NavLink>

          <NavLink
            to="/librarian/manageevents"
            onClick={closeMenu}
            className={({ isActive }) =>
              `librarian-mobile-link ${
                isActive ? "librarian-mobile-active" : ""
              }`
            }
          >
            Events
          </NavLink>

          <NavLink
            to="/librarian/announcement"
            onClick={closeMenu}
            className={({ isActive }) =>
              `librarian-mobile-link ${
                isActive ? "librarian-mobile-active" : ""
              }`
            }
          >
            Announcement
          </NavLink>

          <NavLink
            to="/librarian/profile"
            onClick={closeMenu}
            className={({ isActive }) =>
              `librarian-mobile-link ${
                isActive ? "librarian-mobile-active" : ""
              }`
            }
          >
            Profile Setting
          </NavLink>

          <Link
            to="/"
            onClick={closeMenu}
            className="librarian-mobile-logout"
          >
            Logout
          </Link>

        </nav>

      </header>

      {/* ================= MAIN CONTENT ================= */}

      <main className="librarian-main">

        <Routes>

          <Route
            path="/"
            element={<Dashboard />}
          />

          <Route
            path="books"
            element={<Books />}
          />

          <Route
            path="add-book"
            element={<AddBook />}
          />

          <Route
            path="manageevents"
            element={<ManageEvents />}
          />

          <Route
            path="profile"
            element={<Profile />}
          />

          <Route
            path="announcement"
            element={<Announcement />}
          />

        </Routes>

      </main>

      {/* ================= FOOTER ================= */}

      <footer className="librarian-footer">

        <div className="librarian-footer-container">

          {/* About */}
          <div className="librarian-footer-section">

            <h3>
              📚 Library Management System
            </h3>

            <p>
              Empowering learning through books,
              knowledge, and digital resources.
            </p>

          </div>

          {/* Quick Links */}
          <div className="librarian-footer-section">

            <h3>
              Quick Links
            </h3>

            <Link
              to="/librarian"
              className="librarian-footer-link"
            >
              Dashboard
            </Link>

            <Link
              to="/librarian/books"
              className="librarian-footer-link"
            >
              Books
            </Link>

            <Link
              to="/librarian/add-book"
              className="librarian-footer-link"
            >
              Add Books
            </Link>

            <Link
              to="/librarian/manageevents"
              className="librarian-footer-link"
            >
              Events Management
            </Link>

          </div>

          {/* Contact */}
          <div className="librarian-footer-section">
     <h3>
              Contact
            </h3>

            <p>
              📍{" "}
              <a
                href="https://maps.app.goo.gl/PQHPvX3exzVU9xiX6"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
              >
                Ghalib Library Location
              </a>
            </p>

            <p>
              📞 (021) 33517270
            </p>

            <p>
              📧 idaraeyyadgareghalib@gmail.com
            </p>

            <p>
              🕘 Mon - Fri | 3:00PM-7:30PM
            </p>
          </div>

  

        </div>

        <hr className="librarian-footer-line" />

        <p className="librarian-copyright">
          © {new Date().getFullYear()} Ghalib Library.
          All Rights Reserved.
        </p>

      </footer>

    </div>
  );
};

export default LibrarianLayout;
